export const SN = 'WISHLIST'
export const ADD_ITEM = `${SN}/ADD_ITEM`
export const REMOVE_ITEM = `${SN}/REMOVE_ITEM`
export const CLEAR_WISHLIST = `${SN}/CLEAR_WISHLIST`
export const SET_WISHLIST = `${SN}/SET_WISHLIST`
